import VueRouter from "vue-router";
import index from "../components/index.vue";

/**
 * 登录
 */
import login from "../components/login/login.vue";

/**
 * 小秘书
 */
import secretary from "../components/secretary/index.vue";
import msgDetail from "../components/secretary/message/msgDetail.vue";
import msgManage from "../components/secretary/message/msgManage.vue";
import msgPush from "../components/secretary/message/msgPush.vue";
import newMsg from "../components/secretary/message/newMsg.vue";

/**
 * 用户管理
 */

// 用户管理
import user from "../components/user/index.vue"; // user入口页面
import AllUsers from "../views/UserManage/UserManage/AllUsers.vue"; // 所有用户
import UserVerification from "../views/UserManage/UserManage/UserVerification.vue"; // 用户验证信息
import UploadFacialPhoto from "../views/UserManage/UserManage/UploadFacialPhoto.vue"; // 导入人脸照片
import UploadFacialRecord from "../views/UserManage/UserManage/UploadFacialRecord.vue"; // 人脸导入记录
import UploadFacialDetail from "../views/UserManage/UserManage/UploadFacialDetail.vue"; // 人脸导入记录详情
import campusIdDetail from "../components/user/userM/campusIdDetail.vue"; // 找回学号申请详情
import campusIdManage from "../components/user/userM/campusIdManage.vue"; // 找回学号
import dataRepair from "../components/user/userM/dataRepair.vue"; // 数据修复
import reportManage from "../components/user/userM/reportManage.vue"; // 举报审核
import suspicious from "../components/user/userM/suspicious.vue"; // 可疑用户
import suspiciousRulers from "../components/user/userM/suspiciousRulers.vue"; // 可疑规则
import specific from "../components/user/userM/specific.vue"; // 个性化组件

// 设备管理
import deviceComplain from "../components/user/device/deviceComplain.vue"; // 设备绑定申请

/**
 * 校园管理
 */

// 高校管理
import collegeManage from "../views/UniversityManage/UniversityManage/CollegeManage/CollegeManage.vue"; // 高校管理
import collegeManageDetail from "../views/UniversityManage/UniversityManage/CollegeManage/CollegeManageDetail.vue"; // 高校管理编辑
import departmentManage from "../components/xiaoyuan/GX/departmentManage.vue"; //用户验证信息
import editClass from "../components/xiaoyuan/GX/editClass.vue";
import Manager from "../components/xiaoyuan/GX/Manager.vue";
import newFence from "../components/xiaoyuan/GX/newFence.vue"; // 设置围栏
import pointManage from "../components/xiaoyuan/GX/pointManage.vue"; // 点位管理
import runningFence from "../components/xiaoyuan/GX/runningFence.vue"; // 设置围栏
import schoolManage from "../components/xiaoyuan/GX/schoolManage.vue";
import setMustPoint from "../components/xiaoyuan/GX/setMustPoint.vue"; // 设置必经点
import teacherManage from "../components/xiaoyuan/GX/teacherManage.vue";
import home from "../components/xiaoyuan/index.vue";
import runarea from "../components/xiaoyuan/GX/runarea/index.vue"; // 跑区管理
import runareaDetail from "../components/xiaoyuan/GX/runarea/detail.vue"; // 跑区管理
// import announcementManage from "../components/xiaoyuan/GX/announcement/announcementManage.vue"; // 公告管理
// import announcementDetail from "../components/xiaoyuan/GX/announcement/announcementDetail.vue"; // 公告详情
import announcement from "../views/UniversityManage/UniversityManage/Announcement/Announcement.vue"; // 公告管理
import announcementDetail from "../views/UniversityManage/UniversityManage/Announcement/AnnouncementDetail.vue"; // 公告详情

// 设备管理
// import equipmentList from '../components/xiaoyuan/maintenance/equipment/equipmentList.vue'; // 设备列表
import equipmentList from "../views/UniversityManage/EquipmentManage/EquipmentList/EquipmentList.vue"; // 设备列表
// import equipmentDetail from '../components/xiaoyuan/maintenance/equipment/equipmentDetail.vue'; // 设备详情
import equipmentDetail from "../views/UniversityManage/EquipmentManage/EquipmentList/EquipmentDetail.vue"; // 设备详情
import equipmentBrain from "../views/UniversityManage/EquipmentManage/EquipmentList/EquipmentBrain.vue"; // 外接IPC
// import firmwareManage from '../components/xiaoyuan/maintenance/firmware/firmwareManage.vue'; // 固件包管理
import firmwareManage from "../views/UniversityManage/EquipmentManage/FirmwareManage/FirmwareManage.vue"; // 固件包管理
import masterDevice from "../views/UniversityManage/EquipmentManage/MasterDevice/MasterDevice.vue"; // 主控设备管理

/**
 * 运营管理
 */

// 白名单管理
import clearWhiteList from "../components/user/whitelist/clearWhiteList.vue";
import newWhiteList from "../components/user/whitelist/newWhiteList.vue";

// 作弊管理
import cheatManage from "../components/xiaoyuan/GX/cheatManage.vue";
import classManage from "../components/xiaoyuan/GX/classManage.vue"; // 班级列表

// 富文本编辑器
import about from "../components/yunying/about/about.vue";
import activityDetail from "../components/yunying/activity/activityDetail.vue";

/* 活动 */
// 跑步活动奖励管理
import activityManage from "../components/yunying/activity/activityManage.vue";
// import activityManage from "../views/OperationManage/Activity/ActivityManage/ActivityManage.vue";
import newActivity from "../components/yunying/activity/newActivity.vue";
import newPrize from "../components/yunying/activity/newPrize.vue";
// import newPrize from "../views/OperationManage/Activity/ActivityManage/PrizeAddition.vue";
import prizeDetail from "../components/yunying/activity/prizeDetail.vue";
import prizeManage from "../components/yunying/activity/prizeManage.vue";
// 主题跑
import ThemeRunning from "../views/OperationManage/Activity/ThemeRunning/ThemeRunning.vue";
import ThemeDetail from "../views/OperationManage/Activity/ThemeRunning/ThemeDetail.vue";

// 广告位
import advertData from "../components/yunying/advert/advertData.vue";
import advertManage from "../components/yunying/advert/advertManage.vue";
import advertType from "../components/yunying/advert/advertType.vue";
import newAdvert from "../components/yunying/advert/newAdvert.vue";
// 广告管理
// import AdvertisementManagement from "../components/yunying/AdvertisementManagement/index.vue";
import AdManagement from "../views/OperationManage/AdvertisingSpace/AdManagement/AdManagement.vue";
import AdManagementNew from "../views/OperationManage/AdvertisingSpace/AdManagement/AdManagementNew.vue";
import addPicture from "../components/yunying/article/addPicture.vue";
import articleDetail from "../components/yunying/article/articleDetail.vue";
// 平安合作配置
import CooperationConfig from "../views/OperationManage/AdvertisingSpace/PingAn/CooperationConfig.vue";
import HomeConfigAddition from "../views/OperationManage/AdvertisingSpace/PingAn/HomeConfigAddition.vue";
import MedalConfigAddition from "../views/OperationManage/AdvertisingSpace/PingAn/MedalConfigAddition.vue";
// 资源位配置
import ResourceSpace from "../views/OperationManage/AdvertisingSpace/ResourceSpace/ResourceSpace.vue";
import ResourceDetail from "../views/OperationManage/AdvertisingSpace/ResourceSpace/ResourceDetail.vue";
// 我的页面配置
import MinePage from "../views/OperationManage/AdvertisingSpace/MinePage/MinePage.vue";
import MineDetail from "../views/OperationManage/AdvertisingSpace/MinePage/MineDetail.vue";

// 动态管理页面
// import dynamicManage from "../components/yunying/dynamic/dynamicManage.vue";
import dynamicManage from "../views/OperationManage/Dynamics/DynamicManage/DynamicManage.vue";
import DynamicDetail from "../views/OperationManage/Dynamics/DynamicManage/DynamicDetail.vue";
// import goodsDetail from "../components/yunying/dynamic/goodsDetail.vue";
import goodsDetail from "../views/OperationManage/Dynamics/DynamicManage/GoodsDetail.vue";
// 举报管理
import dynamicReportManage from "../views/OperationManage/Dynamics/ReportManage/ReportManage.vue";
// import vestDynamicManage from "../components/yunying/dynamic/vestDynamicManage.vue";

// 文章管理页面
import articleManage from "../components/yunying/article/articleManage.vue";
import newArticle from "../components/yunying/article/newArticle.vue";
import bannerDetail from "../components/yunying/banner/bannerDetail.vue";

// banner管理页面
import bannerManage from "../components/yunying/banner/bannerManage.vue";
import newBanner from "../components/yunying/banner/newBanner.vue";
import bounceDetail from "../components/yunying/bounce/bounceDetail.vue";

// 首页弹框管理页面
import bounceManage from "../components/yunying/bounce/bounceManage.vue";
import newBounce from "../components/yunying/bounce/newBounce.vue";

// 评论管理页面
import commentManage from "../components/yunying/comment/commentManage.vue";
import criditCardUser from "../components/yunying/distribut/criditCardUser.vue";

// 分销管理
import distribut from "../components/yunying/distribut/distribut.vue";

// 闪屏管理
import flickerScreen from "../components/yunying/flicker/flickerScreen.vue";
import newFlickerScreen from "../components/yunying/flicker/newFlickerScreen.vue";
import HomeDialogDetail from "../components/yunying/HomeDialog/detail.vue";
import HomeDialog from "../components/yunying/HomeDialog/index.vue";

// 首页顶部入口
// import HomeTopEntrance from "../components/yunying/HomeTopEntrance/index.vue";
// import HomeTopEntranceDetail from "../components/yunying/HomeTopEntrance/detail.vue";

// 入口icon管理
import iconManage from "../components/yunying/icon/iconManage.vue";
import newIcon from "../components/yunying/icon/newIcon.vue";
import yunying from "../components/yunying/index.vue";
import changeIntegration from "../components/yunying/integration/changeIntegration.vue";
import downline from "../components/yunying/integration/downline.vue";
import inteChangeDet from "../components/yunying/integration/inteChangeDet.vue";

// 积分
import integration from "../components/yunying/integration/integration.vue";
import integrationDet from "../components/yunying/integration/integrationDet.vue";
import newIntegration from "../components/yunying/integration/newIntegration.vue";

// 问卷调查
import questionnaireManage from "../components/yunying/activity/questionnaireManage.vue";
import questionnaireSurvey from "../components/yunying/activity/questionnaireSurvey.vue";

import addRunBtn from "../components/yunying/runBtn/addRunBtn.vue";
import runBtn from "../components/yunying/runBtn/runBtn.vue";
import newRunPoint from "../components/yunying/runPoint/newRunPoint.vue";

// 跑步点位管理
import runPointManage from "../components/yunying/runPoint/runPointManage.vue";
import sdkAdvert from "../components/yunying/sdkAdvert/sdkAdvert.vue";
import newTalent from "../components/yunying/talent/newTalent.vue";
import talentDetail from "../components/yunying/talent/talentDetail.vue";

// 达人管理
import talentManage from "../components/yunying/talent/talentManage.vue";
import topic_dynamic from "../components/yunying/topic/dynamic.vue";
import newTopic from "../components/yunying/topic/newTopic.vue";
import topicDetail from "../components/yunying/topic/topicDetail.vue";

// 短信管理
import SMSManage from "../components/yunying/SMSManage/index.vue";
import SMSManageDetail from "../components/yunying/SMSManage/Detail/index.vue";
import SMSTask from "../views/OperationManage/MessageManage/SMSTask/SMSTask.vue";
import SMSTaskEdit from "../views/OperationManage/MessageManage/SMSTask/SMSTaskEdit.vue";
import SMSTaskDetail from "../views/OperationManage/MessageManage/SMSTask/SMSTaskDetail.vue";

// 特权角色
// import privilegedRoles from "../components/yunying/privilegedRoles/pages/index.vue";
import privilegedRoles from "../views/OperationManage/UserAdminister/PrivilegeRole/PrivilegeRole.vue";
// import privilegedRolesDetail from "../components/yunying/privilegedRoles/details/index.vue";
import privilegedRolesDetail from "../views/OperationManage/UserAdminister/PrivilegeRole/PrivilegeRoleDetail.vue";

// 用户管理
// import userManagement from "../components/yunying/userManagement/pages/index.vue";
import userManagement from "../views/OperationManage/UserAdminister/UserListing/UserListing.vue";
// 个性化组件
// import UserDiyPage from '../components/yunying/userManagement/diyPage/index.vue';
import UserDiyPage from "../views/OperationManage/UserAdminister/PersonalizedPart/PersonalizedPart.vue";
// import UserDiyEdit from '../components/yunying/userManagement/diyPage/UserDiyEdit.vue';
import UserDiyEdit from "../views/OperationManage/UserAdminister/PersonalizedPart/PersonalizedPartDetail.vue";
// 马甲号管理
import BurnerAccount from "../views/OperationManage/UserAdminister/BurnerAccount/BurnerAccount.vue";
import CommunityUserListing from "../views/OperationManage/UserAdminister/CommunityUserListing/CommunityUserListing.vue";
// 体验卡管理
import ExperienceCard from "../views/OperationManage/UserAdminister/ExperienceCard/ExperienceCard.vue";
import ExperienceCardDetail from "../views/OperationManage/UserAdminister/ExperienceCard/ExperienceCardDetail.vue";
// 会员售卖
import MemberSale from "../views/OperationManage/UserAdminister/MemberSale/MemberSale.vue";
import MemberSaleDetail from "../views/OperationManage/UserAdminister/MemberSale/MemberSaleDetail.vue";
// 会员卡促销
import MemberPromotion from "../views/OperationManage/UserAdminister/MemberPromotion/MemberPromotion.vue";
import MemberPromotionDetail from "../views/OperationManage/UserAdminister/MemberPromotion/MemberPromotionDetail.vue";
// 平台装饰
import PlatformDecoration from "../views/OperationManage/UserAdminister/PlatformDecoration/PlatformDecoration.vue";
// 分享模板
import ShareTemplate from "../views/OperationManage/UserAdminister/ShareTemplate/ShareTemplate.vue";
import ShareTemplateDetail from "../views/OperationManage/UserAdminister/ShareTemplate/ShareTemplateDetail.vue";

// 申请审核
// import applicationReview from "../components/yunying/applicationReview/pages/index.vue";

// 话题管理页面
import topicManage from "../components/yunying/topic/topicManage.vue";
// 快捷评论
import QuickComment from "../components/yunying/quickComment/QuickComment.vue";

// 话题栏首位入口
// import TopicsTopEntrance from "../components/yunying/TopicsTopEntrance/index.vue";
// import TopicsTopEntranceDetail from "../components/yunying/TopicsTopEntrance/detail.vue";

// 弹幕管理
import CatalogManagement from "../components/yunying/BulletinManagement/CatalogManagement/Page/index.vue";
import PublicBulletinManagement from "../components/yunying/BulletinManagement/PublicBulletinManagement/Page/index.vue";
import PublicBulletinManagementDetail from "../components/yunying/BulletinManagement/PublicBulletinManagement/Detail/index.vue";
import CustomizedBulletinManagement from "../components/yunying/BulletinManagement/CustomizedBulletinManagement/Page/index.vue";

// 系统配置
import SystemConfig from "../views/OperationManage/SystemConfig/SystemConfig/SystemConfig.vue";
// 菜单管理
import MenuManage from "../views/UniversityManage/UniversityManage/MenuManage/MenuManage.vue";
// 运动会统计
import SportsStatistic from "../views/UniversityManage/UniversityManage/SportsStatistic/SportsStatistic.vue";

//照片管理
import photoList from "../components/yunying/photo/photoList.vue";
import UploadPhotoFacialRecord from "../components/yunying/photo/UploadPhotoFacialRecord.vue"; // 照片导入记录
import UploadPhotoFacialDetail from "../components/yunying/photo/UploadPhotoFacialDetail.vue"; // 照片导入记录详情
import photoImport from "../components/yunying/photo/photoImport.vue"; // 照片导入

/**
 * 运动课程
 */
import courseManage from "../components/yunying/course/courseManage.vue"; // 课程管理
import categoryManage from "../components/yunying/course/categoryManage.vue"; // 课程分类管理
import categoryEdit from "../components/yunying/course/categoryEdit.vue"; // 课程分类编辑/新增
import courseEdit from "../components/yunying/course/courseEdit.vue"; // 课程编辑/新增

/**
 * 文案管理
 */
import MemberExpireRemind from "../views/OperationManage/Copywriting/MemberExpireRemind/MemberExpireRemind.vue"; // 会员临期提醒
import RunShareCopy from "../views/OperationManage/Copywriting/RunShareCopy/RunShareCopy.vue"; // 跑后分享文案

// 线上赛管理
import matchManage from "../components/yunying/onlineMatch/matchManage.vue";
import matchDetail from "../components/yunying/onlineMatch/matchDetail.vue";
import signUpManage from "../components/yunying/onlineMatch/signUpManage.vue";
import matchPrizeManage from "../components/yunying/onlineMatch/matchPrizeManage.vue";
// 创建一个路由器实例，并且配置路由规则
const router = new VueRouter({
  mode: "hash",
  base: __dirname,
  routes: [
    { path: "/", component: login },
    { path: "/index", component: index },
    {
      path: "/login",
      name: "login",
      meta: { auth: false },
      component: login,
    },
    {
      path: "/secretary",
      component: secretary,
      children: [
        { path: "/message/msgManage", component: msgManage },
        { path: "/message/msgPush", component: msgPush },
        { path: "/message/msgDetail", component: msgDetail },
        { path: "/message/newMsg", component: newMsg },
      ],
    },
    {
      path: "/user",
      component: user,
      children: [
        {
          path: "/user/all",
          meta: { keepAlive: true, refresh: false },
          component: AllUsers,
        },
        {
          path: "/user/verification",
          meta: { keepAlive: true, refresh: false },
          component: UserVerification,
        },
        { path: "/user/facial/photo", component: UploadFacialPhoto },
        { path: "/user/facial/record", component: UploadFacialRecord },
        { path: "/user/facial/detail", component: UploadFacialDetail },
        { path: "/userM/campusIdManage", component: campusIdManage },
        { path: "/userM/campusIdDetail", component: campusIdDetail },
        { path: "/userM/suspicious", component: suspicious },
        { path: "/userM/suspiciousRulers", component: suspiciousRulers },
        { path: "/userM/reportManage", component: reportManage },
        { path: "/userM/dataRepair", component: dataRepair },
        { path: "/userM/specific", component: specific },
        { path: "/device/deviceComplain", component: deviceComplain },
        { path: "/whitelist/clearWhiteList", component: clearWhiteList },
        { path: "/whitelist/newWhiteList", component: newWhiteList },
      ],
    },
    {
      path: "/xiaoyuan",
      component: home,
      children: [
        {
          path: "college/manage",
          meta: { keepAlive: true, refresh: false },
          component: collegeManage,
        },
        { path: "college/manage/detail", component: collegeManageDetail },

        { path: "GX/schoolManage", component: schoolManage },
        { path: "GX/Manager", component: Manager },
        { path: "GX/editClass", component: editClass },
        { path: "GX/pointManage", component: pointManage },
        { path: "GX/setMustPoint", component: setMustPoint },
        { path: "GX/cheatManage", component: cheatManage },
        { path: "GX/teacherManage", component: teacherManage },
        { path: "GX/departmentManage", component: departmentManage },
        { path: "GX/classManage", component: classManage },
        { path: "GX/runningFence", component: runningFence },
        { path: "GX/newFence", component: newFence },
        { path: "GX/runarea", component: runarea },
        { path: "GX/runareaDetail", component: runareaDetail },
        // { path: "GX/announcement/announcementManage", component: announcementManage },
        // { path: "GX/announcement/announcementDetail", component: announcementDetail },
        { path: "announcement/manage", component: announcement },
        { path: "announcement/detail", component: announcementDetail },
        { path: "menu/menu", component: MenuManage },
        { path: "sports/statistic", component: SportsStatistic },

        // { path: "maintenance/equipment/equipmentList", component: equipmentList },
        {
          path: "equipment/list",
          meta: { keepAlive: true, refresh: false },
          component: equipmentList,
        },
        { path: "equipment/list/detail", component: equipmentDetail },
        { path: "equipment/list/detail/brain", component: equipmentBrain },
        // { path: "maintenance/equipment/equipmentDetail", component: equipmentDetail },
        // { path: "maintenance/firmware/firmwareManage", component: firmwareManage },
        { path: "firmware/manage", component: firmwareManage },
        { path: "master/device", component: masterDevice },
      ],
    },
    {
      path: "/yunying",
      component: yunying,
      name: "yunying",
      children: [
        { path: "article/articleManage", component: articleManage },
        { path: "article/newArticle", component: newArticle },
        { path: "article/articleDetail", component: articleDetail },
        { path: "article/addPicture", component: addPicture },

        { path: "topic/topicManage", component: topicManage },
        { path: "topic/newTopic", component: newTopic },
        { path: "topic/topicDetail", component: topicDetail },
        { path: "topic/dynamic", component: topic_dynamic },

        { path: "dynamic/dynamicManage", component: dynamicManage },
        { path: "dynamic/manage/detail", component: DynamicDetail },
        // { path: "dynamic/vestDynamicManage", component: vestDynamicManage },
        { path: "dynamic/goodsDetail", component: goodsDetail },
        { path: "dynamic/reportManage", component: dynamicReportManage },

        { path: "comment/commentManage", component: commentManage },

        { path: "banner/bannerManage", component: bannerManage },
        { path: "banner/newBanner", component: newBanner },
        { path: "banner/bannerDetail", component: bannerDetail },

        { path: "bounce/bounceManage", component: bounceManage },
        { path: "bounce/newBounce", component: newBounce },
        { path: "bounce/bounceDetail", component: bounceDetail },

        { path: "flicker/flickerScreen", component: flickerScreen },
        { path: "flicker/newFlickerScreen", component: newFlickerScreen },

        { path: "icon/iconManage", component: iconManage },
        { path: "icon/newIcon", component: newIcon },

        {
          path: "runPoint/runPointManage",
          component: runPointManage,
          name: "runPointManage",
        },
        {
          path: "runPoint/newRunPoint",
          component: newRunPoint,
          name: "newRunPoint",
        },

        {
          path: "activity/activityManage",
          meta: { keepAlive: true, refresh: false },
          component: activityManage,
        },
        { path: "activity/activityDetail", component: activityDetail },
        { path: "activity/newActivity", component: newActivity },
        { path: "activity/prizeManage", component: prizeManage },
        { path: "activity/prizeDetail", component: prizeDetail },
        { path: "activity/newPrize", component: newPrize },
        { path: "activity/theme/running", component: ThemeRunning },
        { path: "activity/theme/detail", component: ThemeDetail },

        { path: "integration/integration", component: integration },
        { path: "integration/newIntegration", component: newIntegration },
        { path: "integration/changeIntegration", component: changeIntegration },
        { path: "integration/integrationDet", component: integrationDet },
        { path: "integration/inteChangeDet", component: inteChangeDet },
        { path: "integration/downline", component: downline },

        { path: "about/about", component: about },
        { path: "sdkAdvert/sdkAdvert", component: sdkAdvert },

        {
          path: "activity/questionnaireManage",
          meta: { keepAlive: true, refresh: false },
          component: questionnaireManage,
        },
        {
          path: "activity/questionnaireSurvey",
          component: questionnaireSurvey,
        },

        { path: "advert/advertType", component: advertType },
        { path: "advert/advertManage", component: advertManage },
        { path: "advert/newAdvert", component: newAdvert },
        { path: "advert/advertData", component: advertData },
        { path: "advert/runBtn", component: runBtn },
        { path: "advert/addRunBtn", component: addRunBtn },
        { path: "advert/HomeDialog", component: HomeDialog },
        { path: "advert/HomeDialog/Detail", component: HomeDialogDetail },

        { path: "advertising/ad/management", component: AdManagement },
        { path: "advertising/ad/managementNew", component: AdManagementNew },

        {
          path: "advertising/pingan/cooperation",
          meta: { keepAlive: true, refresh: false },
          component: CooperationConfig,
        },
        {
          path: "advertising/pingan/home/config",
          component: HomeConfigAddition,
        },
        {
          path: "advertising/pingan/medal/config",
          component: MedalConfigAddition,
        },
        { path: "advertising/resource/space", component: ResourceSpace },
        { path: "advertising/resource/detail", component: ResourceDetail },
        { path: "advertising/mine/page", component: MinePage },
        { path: "advertising/mine/detail", component: MineDetail },

        { path: "distribut/distribut", component: distribut },
        { path: "distribut/criditCardUser", component: criditCardUser },

        { path: "talent/talentManage", component: talentManage },
        { path: "talent/newTalent", component: newTalent },
        { path: "talent/talentDetail", component: talentDetail },

        // { path: "HomeTopEntrance", component: HomeTopEntrance },
        // { path: "HomeTopEntrance/Detail", component: HomeTopEntranceDetail },

        // { path: "TopicsTopEntrance", component: TopicsTopEntrance },
        // { path: "TopicsTopEntrance/Detail", component: TopicsTopEntranceDetail, },

        { path: "user/privilege/role", component: privilegedRoles },
        {
          path: "user/privilege/role/detail",
          component: privilegedRolesDetail,
        },

        { path: "userManagement", component: userManagement },
        {
          path: "userDiyPage",
          meta: { keepAlive: true, refresh: false },
          component: UserDiyPage,
        },
        { path: "userDiyEdit", component: UserDiyEdit },
        { path: "user/burner/account", component: BurnerAccount },
        { path: "community/user/list", component: CommunityUserListing },
        { path: "community/quickComment", component: QuickComment },

        { path: "user/experience/card", component: ExperienceCard },
        {
          path: "user/experience/card/detail",
          component: ExperienceCardDetail,
        },

        { path: "user/member/sale", component: MemberSale },
        { path: "user/member/sale/detail", component: MemberSaleDetail },
        { path: "user/member/promotion", component: MemberPromotion },
        {
          path: "user/member/promotionDetail",
          component: MemberPromotionDetail,
        },

        { path: "platform/decoration", component: PlatformDecoration },
        { path: "user/share/template", component: ShareTemplate },
        { path: "user/share/template/detail", component: ShareTemplateDetail },

        // { path: "applicationReview", component: applicationReview, },
        { path: "SMSManage", component: SMSManage },
        { path: "SMSManage/Detail", component: SMSManageDetail },
        { path: "sms/task", component: SMSTask },
        { path: "sms/task/edit", component: SMSTaskEdit },
        { path: "sms/task/detail", component: SMSTaskDetail },

        { path: "CatalogManagement", component: CatalogManagement },

        {
          path: "PublicBulletinManagement",
          meta: { keepAlive: true, refresh: false },
          component: PublicBulletinManagement,
        },
        {
          path: "PublicBulletinManagement/Detail",
          component: PublicBulletinManagementDetail,
        },
        {
          path: "CustomizedBulletinManagement",
          component: CustomizedBulletinManagement,
        },

        { path: "system/config", component: SystemConfig },
        { path: "photo/photoList", component: photoList },
        { path: "/photo/photoRecord", component: UploadPhotoFacialRecord },
        { path: "/photo/photoDetail", component: UploadPhotoFacialDetail },
        { path: "/photo/photoImport", component: photoImport },

        // 运动课程路由
        { path: "course/courseManage", component: courseManage },
        { path: "course/categoryManage", component: categoryManage },
        { path: "course/category/edit/:id", component: categoryEdit },
        { path: "course/edit/:id?", component: courseEdit },

        // 文案管理路由
        {
          path: "copywriting/memberExpireRemind",
          component: MemberExpireRemind,
        },
        { path: "copywriting/runShareCopy", component: RunShareCopy },

        // 线上赛管理路由
        { path: "onlineMatch/matchManage", component: matchManage },
        { path: "onlineMatch/matchDetail", component: matchDetail },
        { path: "onlineMatch/signUpManage", component: signUpManage },
        { path: "onlineMatch/matchPrizeManage", component: matchPrizeManage },
      ],
    },
    {
      path: "*",
      redirect: "/login",
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js